import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import CourseForm from 'components/organisms/forms/CourseForm'

import { crudActionsMap } from 'utils/helpers'
import CourseInfo from 'components/molecules/CourseInfo'
import { Box } from '@mui/material'

const CourseCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const user = useSelector((state: RootState) => state['user'].user)

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete' || user?.role === 'special_teacher'

  return (
    <>
      <PageHeading title={`${t('common.courses')} / ${t('common.' + action)}`} />
      <PageBody>
        <CourseForm action={action} id={id} viewOnly={viewOnly} />
        
        { /* id && <Box sx={{ marginTop: '2rem' }}><CourseInfo id={ parseInt(id) } course_chapter_id={0} tabText={`${t('common.overview')}`} /></Box> */ }
      </PageBody>
    </>
  )
}
export default CourseCrudPage
